<footer class="footer">
  <div class="container">
    <!-- Footer Main Content -->
    <div class="footer-main">
      <div class="footer-content">

        <!-- Company Info Section -->
        <div class="footer-section">
          <div class="footer-logo">
            <img src="../../../assets/adicompany.png" alt="Aadinath Enterprise" class="logo-icon">
            <div class="logo-text">
              <span class="logo-main">AADINATH</span>
              <span class="logo-sub">ENTERPRISE</span>
            </div>
          </div>
          <p class="footer-description">
            Leading manufacturer of high-quality packaging solutions including field sample bags,
            mining pre-numbered bags, seed packing bags, and custom industrial packaging.
          </p>
          <div class="social-links">
            <a *ngFor="let social of socialLinks" [href]="social.url" class="social-link" target="_blank"
              rel="noopener noreferrer" [title]="social.name">
              <i [class]="social.icon"></i>
            </a>
          </div>
        </div>

        <!-- Quick Links Section -->
        <div class="footer-section">
          <h3 class="footer-title">Quick Links</h3>
          <ul class="footer-links">
            <li *ngFor="let link of quickLinks">
              <a [routerLink]="link.path" class="footer-link">{{ link.label }}</a>
            </li> 
          </ul>
        </div>

        <!-- Products Section -->
        <div class="footer-section">
          <h3 class="footer-title">Our Products</h3>
          <ul class="footer-links">
            <li *ngFor="let product of productCategories">
              <a href="#" class="footer-link">{{ product }}</a>
            </li>
          </ul>
        </div>

        <!-- Contact Info Section -->
        <div class="footer-section">
          <h3 class="footer-title">Contact Info</h3>
          <div class="contact-info">
            <div class="contact-item">
              <span class="contact-icon">📍</span>
              <span class="contact-text">Address -Aadinath Enterprises
                Near Amrut paradise, next to Shri Ganesh parking point,manisha nagar gate no-2,kalwa thane
                -400605.</span>
            </div>
            <div class="contact-item">
              <span class="contact-icon">📞</span>
              <span class="contact-text">+91 9768301159</span>
            </div>
            <div class="contact-item">
              <span class="contact-icon">✉️</span>
              <span class="contact-text">Aadinathenterprises21&#64;gmail.com</span>
            </div>

          </div>
        </div>

      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom"> 
      <div class="footer-bottom-content">
        <p class="copyright">
          © {{ currentYear }} Aadinath Enterprise. All rights reserved.
        </p>
        <div class="footer-bottom-links">
          <button class="bottom-link" (click)="openPrivacyPolicy()" type="button">
            Privacy Policy
          </button>
          <button class="bottom-link" (click)="openTerms()" type="button">
            Terms & Conditions
          </button>
          <a href="#" class="bottom-link">Disclaimer</a>
        </div>
      </div>
    </div>
  </div>

  <!-- Privacy Policy Modal -->
  <div class="policy-modal" *ngIf="showPrivacyPolicy" (click)="closePrivacyPolicy()" (keydown)="onKeyDown($event)">
    <div class="policy-modal-content" (click)="$event.stopPropagation()">
      <div class="policy-modal-header">
        <h2>Privacy Policy</h2>
        <button class="close-btn" (click)="closePrivacyPolicy()" type="button" aria-label="Close Privacy Policy">
          &times;
        </button>
      </div>
      <div class="policy-modal-body" [innerHTML]="privacyPolicyContent"></div>
    </div>
  </div>

  <!-- Terms & Conditions Modal -->
  <div class="policy-modal" *ngIf="showTerms" (click)="closeTerms()" (keydown)="onKeyDown($event)">
    <div class="policy-modal-content" (click)="$event.stopPropagation()">
      <div class="policy-modal-header">
        <h2>Terms & Conditions</h2>
        <button class="close-btn" (click)="closeTerms()" type="button" aria-label="Close Terms & Conditions">
          &times;
        </button>
      </div>
      <div class="policy-modal-body" [innerHTML]="termsContent"></div>
    </div>
  </div>
</footer>